import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

// Bootstrap JS only (CSS is now imported via SCSS)
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// Custom SCSS (includes Bootstrap CSS)
import "@/assets/scss/main.scss";

createApp(App).use(router).mount("#app");
